import React, { useState, useEffect } from "react";
import PropTypes from "kf-proptypes/widgets";

import { useUserStore } from "base/stores";

import { UserMenuItem } from "../usermenuitem/index.jsx";
import { SearchInput, SEARCH_TYPE } from "../../inputs/index.jsx";
import { Menu, MenuItem } from "../../inputs/dropdown/menu.jsx";

import styles from "./usermenu.css";

/**
 * Display user menu list with search bar
 */

export function UserMenu(props) {
  const {
    dataSource,
    onSelect,
    onSearch,
    onSearchDebounced,
    selection,
    placeholder = ""
  } = props;

  const [currentDatasource, setCurrentDatasource] = useState([]);

  useEffect(function updateDateSource() {
    if (!dataSource) {
      useUserStore
        .getState()
        .getUsers()
        .then((users) => {
          setCurrentDatasource(users);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const defaultSearch = ({ search }) => {
    useUserStore
      .getState()
      .getUsers(search, 1)
      .then((users) => {
        setCurrentDatasource(users);
      });
  };

  return (
    <div className={styles.menu}>
      {(onSearch || onSearchDebounced) && (
        <SearchInput
          onChange={onSearch}
          onChangeDebounced={(search) => {
            if (onSearchDebounced) {
              onSearchDebounced(search);
            } else {
              defaultSearch({ search });
            }
          }}
          type={SEARCH_TYPE.MINIMAL}
          placeholder={placeholder}
        />
      )}
      <div
        className={`${styles.menuitems} ${
          onSearch || onSearchDebounced ? styles.searchBar : ""
        }`}
      >
        <Menu selection={selection}>
          {(dataSource || currentDatasource).map((user) => {
            return (
              <MenuItem
                key={user._id}
                onClick={() => {
                  onSelect && onSelect(user);
                }}
              >
                <UserMenuItem
                  userId={user._id}
                  name={user.Name}
                  email={user.Email}
                />
              </MenuItem>
            );
          })}
        </Menu>
      </div>
    </div>
  );
}

UserMenu.propTypes = {
  /**
   * Users details to display in lost
   */
  dataSource: PropTypes.arrayOf(
    PropTypes.shape({
      Name: PropTypes.string.isRequired,
      Email: PropTypes.string,
      Kind: PropTypes.string.isRequired,
      _id: PropTypes.string.isRequired
    })
  ).isRequired,
  /**
   * function will trigger if user click the user name in the list
   */
  onSelect: PropTypes.func,
  /**
   * search the list of users and list on results that match the search bar
   */
  onSearch: PropTypes.func,
  /**
   * search the list of users and list on results that match the search query with debounce of 300ms default
   */
  onSearchDebounced: PropTypes.func,
  /**
   * provide already selected value
   */
  selection: PropTypes.string,
  /**
   * placeholder for the search bar
   */
  placeholder: PropTypes.string
};
UserMenu.defaultProps = {
  placeholder: ""
};
